// extracted by mini-css-extract-plugin
export default {"titleContainer":"PopularArticles_titleContainer__EfmSY"};